import axios from 'axios'
import Swal from 'sweetalert2'
import { on } from 'delegated-events'

export default class ProductCardAction {
    constructor() {
        this.bindEvents()
    }

    bindEvents() {
        on('click', '.wishlist-trigger', this.handleWishlish.bind(this))
        on('click', '.add-to-card-trigger', this.handleAddToCart.bind(this))
    }

    handleWishlish(event) {
        const customer_id = event.target.getAttribute('data-customer-id')
        const title = event.target.getAttribute('data-product-title')
        const product = event.target.getAttribute('data-product')
        const payload = { customer_id, product }

        event.preventDefault()

        axios.post('https://api.timbashield.strafe.dev/api/v1/wishlist/add', payload).then((response) => {
            Swal.fire({
                title: 'Wishlist',
                text: `${title} has been added to your wishlist.`,
                icon: 'info',
            })
        })
    }

    handleAddToCart(event) {
        const productId = event.target.getAttribute('data-product-id')

        const payload = {
            items: [
                {
                    id: parseInt(productId),
                    quantity: 1,
                },
            ],
        }

        event.preventDefault()

        axios.post('/cart/add.js', payload).then((response) => {
            const { items } = response.data
            events.publish('cart', items[0])
            events.publish('open-panel')
        })
    }
}
